<template>
    <div class="modal" :class="bemFacet">
        <div class="modal--close-wrap">
            <div class="modal--close">
                <button class="modal--close-button btn btn__bubble btn__large"
                        :class="buttonClasses"
                        @click.prevent="closeOverlay">
                    <cmp-ink-ripple v-if="!isSmallDevice"></cmp-ink-ripple>
                    <cmp-icon class="btn--bubble-icon" symbol="close" size="small"></cmp-icon>
                </button>
            </div>
        </div>

        <header class="modal--header" v-if="!!$slots.header">
            <slot name="header"></slot>
        </header>
        <main class="modal--body" v-if="!!$slots.default">
            <slot></slot>
        </main>
        <footer class="modal--footer" v-if="!!$slots.footer">
            <slot name="footer"></slot>
        </footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import bemMixin from 'framework/mixins/bem';
    import { toNumeral, numerals } from 'util/dom/mq';


    export default {
        mixins: [
            bemMixin('modal'),
        ],
        computed: {
            ...mapGetters(['viewport']),
            buttonClasses() {
                return [
                    `btn__${ this.isSmallDevice ? 'light' : 'overlay' }`,
                ];
            },
            isSmallDevice() {
                return toNumeral(this.viewport.mq.query) <= numerals.SM;
            },
        },
        methods: {
            ...mapActions(['closeOverlay']),
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/ui/modal/index.vue?389a09ce